import { EmptyState, TentativeTimeIcon } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface NeverSyncedEmptyStateProps {
  size?: 'small' | 'medium'
}

export function NeverSyncedEmptyState({
  size = 'small',
}: NeverSyncedEmptyStateProps): JSX.Element {
  return (
    <EmptyState size={size}>
      <EmptyState.Icon>
        <TentativeTimeIcon stroke={1.5} />
      </EmptyState.Icon>
      <EmptyState.Description>
        We&apos;re loading your data — it can take a few minutes.
      </EmptyState.Description>
    </EmptyState>
  )
}
